import type { PublicPageHeadingProps } from './types';

import React from 'react';

import { Stack, Text } from '@/components';

const PublicPageHeading: React.FC<PublicPageHeadingProps> = ({
  title,
  ...restProps
}) => {
  return (
    <Stack
      backgroundColor="complimentary.3"
      w="full"
      maxW={1440}
      mx="auto"
      minH={{ base: '60px', md: '100px' }}
      justify="center"
      p={4}
      my={{ base: 2.5, md: 4 }}
      {...restProps}
    >
      <Text
        textAlign="center"
        fontSize={{ base: '2xl', md: '44px' }}
        fontWeight={700}
      >
        {title}
      </Text>
    </Stack>
  );
};

export default PublicPageHeading;
